export default {
    icon: {
        color: '{form.field.icon.color}'
    }
};
